import { useEffect } from "react";

// Lightweight per-page SEO: sets <title>, meta description and canonical.
const SITE = "https://www.newspaceuk.com";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, path = "/", noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `${SITE}${path}`);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setCanonical(`${SITE}${path}`);
    const robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) setMeta("name", "robots", "noindex, nofollow");
    else if (robots) robots.remove();
  }, [title, description, path, noindex]);

  return null;
}
